import { createAsyncThunk } from "@reduxjs/toolkit";
import { handleApiError } from "Features/Common/ErrorHandler";
import { UserServices } from "Services/axios/User.Service";

export const fetchCodeOTP = createAsyncThunk(
  'Schedules/fetchCodeOTP',
  async () => {
    try {
      const response = await UserServices.generateOTP();
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  }
);